export const BLOG_CATEGORIES = [
  'Company News',
  'Product Updates',
  'Industry Insights',
  'Customer Stories',
  'Technology',
] as const;

export type BlogCategoryType = (typeof BLOG_CATEGORIES)[number];

export const categoryToSlug = (category: string): string =>
  category
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

export const slugToCategory = (slug: string): BlogCategoryType | undefined =>
  BLOG_CATEGORIES.find((c) => categoryToSlug(c) === slug);
